import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-section">
      <div className="about-layout">
        <div className="about-left">
          <h1 className="about-section-h1">A B O U T ————— </h1>
        </div>

        <div className="about-right">
          {/* Top row: Intro */}
          <div className="about-columns-top">
            <div className="about-text-section">
              <p className="about-short">I’m Tetiana</p>
              <div className="about-text">
                <p>
                  I am a Full-Stack Product Engineer and Technical Lead with
                  over 9 years in the IT industry, including 3+ years
                  specializing in coding. I've completed my Master's in Software Development program at Boston
                  University, one of the top 100 universities globally. This
                  program provided me with a highly demanded knowledge of
                  computer language theory, algorithms, databases, networks,
                  security, operating systems, web & software development, and
                  more.
                  <br />
                  <br />
                  Alongside my programming skills, I have hands-on experience
                  leading development from idea to release, coordinating
                  engineers, owning technical execution across the frontend and
                  backend, and translating stakeholder goals into
                  production-ready applications. I strive to use all my combined
                  commercial experience and academic knowledge to build
                  effective, full-stack solutions that work close to users and
                  business needs.
                </p>
              </div>
            </div>
            <div className="about-empty-column"></div>
          </div>

          {/* Bottom row: Skills + Certifications */}
          <div className="about-columns-bottom">
            {/* Skills */}
            <div className="about-skill-column">
              <h3>EDUCATION</h3>
              <p>
                <strong>Master of Science, Software Development,</strong> Boston
                University
              </p>
              <h3>TECHNICAL SKILLS</h3>
              <p>
                <strong>Languages:</strong> JavaScript, TypeScript, Python,
                Java, HTML, CSS / SCSS
              </p>
              <p>
                <strong>Frameworks & Libraries:</strong> React.js, Vite,
                Node.js, Express.js, Passport.js, GraphQL, Bootstrap
              </p>
              <p>
                <strong>Databases:</strong> PostgreSQL, MongoDB, Mongoose,
                SQLite, MongoDB Atlas
              </p>
              <p>
                <strong>Tools & IDEs:</strong> GitHub, GitHub Actions, Postman,
                Visual Studio Code, IntelliJ IDEA, Docker, PyCharm, Spyder IDE,
                Anaconda / Anaconda Navigator
              </p>
              <p>
                <strong>Design & Prototyping:</strong> Figma, UI/UX Design, UX
                Research, Wireframing, Prototyping, CJM, User Flows, Responsive
                Web Design, Lucidchart
              </p>
              <p>
                <strong>Collaboration Tools:</strong> Jira, Slack, Discord,
                Discourse, GitHub Projects / Kanban
              </p>
              <p>
                <strong>Other:</strong> Hosting (Netlify, Heroku, Render), REST
                API, OpenAI API
              </p>
              <h3>SOFT SKILLS</h3>
              <p>
                Determined, enthusiastic, perceptive, flexible, and initiative
                in work; ability to work efficiently both individually and in a
                team; critical thinking and decision-making skills; willingness
                to learn fast; good sense of humor; excellent organizational and
                time-management skills
              </p>
            </div>
            {/* Certificates */}
            <div className="about-cert-column">
              <h4>Transcript</h4>
              <a
                href="/transcript_Tetiana_Korchynska_.pdf"
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/transcript.png" alt="Transcript" />
              </a>
              <h4>Certifications in Front-End Development</h4>
              <div className="cert-row">
                {[
                  {
                    src: "/shecodes1.png",
                    link: "https://www.shecodes.io/diplomas/61790a4c24294c038f17343a0183fa58",
                  },
                  {
                    src: "/shecodes2.png",
                    link: "https://www.shecodes.io/certificates/c59b5f960e9b9c588c8b340d3b415f48?_gl=1*1g9x9pu*_gcl_au*MTE2NDk4MjcxNi4xNzUwNzkxOTE0",
                  },
                  {
                    src: "/shecodes3.png",
                    link: "https://www.shecodes.io/certificates/2e9750e04026ee23ed0f5ca2d143f52e?_gl=1*1ji1j1r*_gcl_au*MTE2NDk4MjcxNi4xNzUwNzkxOTE0",
                  },
                ].map(({ src, link }, i) => (
                  <a
                    key={i}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={src} alt={`Front-End cert ${i + 1}`} />
                  </a>
                ))}
              </div>
              <div className="cert-row">
                {[
                  {
                    src: "/shecodes4.png",
                    link: "https://www.shecodes.io/certificates/52c6c8863207c60cc92e03cc33127f4e?_gl=1*jatc99*_gcl_au*MTE2NDk4MjcxNi4xNzUwNzkxOTE0",
                  },
                  {
                    src: "/udemy.jpg",
                    link: "https://www.udemy.com/certificate/UC-89d13e8c-c724-40c0-8610-b9dd7439ae71/",
                  },
                ].map(({ src, link }, i) => (
                  <a
                    key={i}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={src} alt={`Front-End cert ${i + 4}`} />
                  </a>
                ))}
              </div>

              <h4>Certifications in UI/UX Design</h4>
              <div className="cert-row">
                {[
                  {
                    src: "/goit1.png",
                    link: "https://drive.google.com/file/d/1qBgbpYqgVg7L3k8eJbeCUNi-eZmimamK/view?usp=drive_link",
                  },
                  {
                    src: "/goit2.png",
                    link: "https://drive.google.com/file/d/1ujrqOH-qoEM2XcWcJR96U9k2RVNDF2vw/view?usp=drive_link",
                  },
                  {
                    src: "/goit3.png",
                    link: "https://drive.google.com/file/d/1s7qKLBHfCsrnwXnVg0-5XUlTbwytxMTZ/view?usp=drive_link",
                  },
                ].map(({ src, link }, i) => (
                  <a
                    key={i}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={src} alt={`UI/UX cert ${i + 1}`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
